export enum InvitationType {
  UNP = 'unp',
  IDP = 'idp',
}

export enum InvitationAction {
  LOGIN = 'login',
  SIGNUP = 'signup',
}
